// extracted by mini-css-extract-plugin
export default {"container":"Create_container__dV2hL","mobile":"Create_mobile__0jyUF","modalNotification":"Create_modalNotification__1WUNh","modalCloseButton":"Create_modalCloseButton__6QuXN"};